module.exports = __webpack_public_path__ + "img/dash-VARILUX-X-SERIES_full_white.66a153b5.png";